module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-07.5993586c.png";